module.exports = __webpack_public_path__ + "static/ND_Patientsite_homepage_slider1-mobile-1c33d0e51a247b853cdc04271679b4ea.png";